import React, { ReactNode } from 'react'

import Navbar from '@/components/layouts/changelog/Navbar'
import CommonLayout from '@/components/layouts/common/Layout'

interface LayoutProps {
  children: ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <CommonLayout
      navbar={Navbar}
      innerClassName="bg-primary-50 dark:bg-default-dark"
    >
      {children}
    </CommonLayout>
  )
}

export const getLayout = (page: ReactNode) => <Layout>{page}</Layout>

export default Layout
